<template>
    <v-tooltip :disabled="hideTooltip" top>
        <template v-slot:activator="{ props }">
            <div
                v-bind="props"
                ref="truncated"
                class="truncate-text"
                @mouseover="checkTooltipRequired"
            >
                {{ params.valueFormatted || params.value }}
            </div>
        </template>
        {{ params.valueFormatted || params.value }}
    </v-tooltip>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    data() {
        return {
            hideTooltip: null,
        };
    },
    methods: {
        checkTooltipRequired(event) {
            // scrollWidth includes content not visible due to overflow, whilst offsetWidth includes only visible content.
            // If these differ, then a tooltip is required to display the full text.
            const { offsetWidth, scrollWidth } = event.target;
            this.hideTooltip = offsetWidth === scrollWidth;
        },
    },
});
</script>
